import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { bindAll } from '@bibliocommons/utils-react';
import { childrenShape } from '@bibliocommons/bc-prop-types';
import { TextButton } from '@bibliocommons/deprecated-base-buttons';
import { Pencil } from '@bibliocommons/deprecated-base-icons';
import AccessibleTextArea from '@bibliocommons/deprecated-base-accessibility-text-area';
import './InlineTextArea.scss';

export class InlineTextArea extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      editMode: false
    };
    bindAll(this);
  }

  handleBlur() {
    this.setState({ editMode: false });
  }

  handleButtonFocus() {
    if (this.props.openOnFocus) {
      this.setState({ editMode: true });
    }
  }

  handleClick() {
    this.setState({ editMode: true });
  }

  renderValue() {
    if (this.props.value) {
      return (
        <div className="text-area-value">
          {this.props.children}
          <TextButton
            className="edit-button"
            handleClick={this.handleClick}
            onFocus={this.handleButtonFocus}
            dataKey={this.props.buttonTestId}
            data-test-id={this.props.buttonTestId}
            aria-label={this.props.intl.formatMessage({ id: 'button_edit' })}
          >
            <Pencil />
            <FormattedMessage id="button_edit" />
          </TextButton>
        </div>
      );
    }
    return (
      <TextButton
        handleClick={this.handleClick}
        onFocus={this.handleButtonFocus}
        className="prompt"
        aria-label={this.props.intl.formatMessage({ id: 'button_edit' })}
        dataKey={this.props.buttonTestId}
        data-test-id={this.props.buttonTestId}
      >
        <Pencil />
        <span>{this.props.prompt}</span>
      </TextButton>
    );
  }

  render() {
    const extraClasses = this.props.highlightOnHover ? 'highlight-on-hover' : '';
    return (
      <div className={`cp-inline-text-area ${extraClasses}`}>
        {this.state.editMode ? (
          <AccessibleTextArea
            setFocus
            id={this.props.id}
            value={this.props.value}
            suggestedMaxLength={this.props.suggestedMaxLength}
            maxLength={this.props.maxLength}
            handleBlur={this.handleBlur}
            className={this.props.customClass}
            handleChange={this.props.handleChange}
            errorKey="InlineTextArea"
            labelledById={this.props.labelledById}
            describedById={this.props.describedById}
            testId={this.props.inputTestId}
            fitToText={this.props.fitToText}
          />
        ) : (
          this.renderValue()
        )}
      </div>
    );
  }
}

InlineTextArea.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  handleChange: PropTypes.func,
  prompt: PropTypes.string,
  maxLength: PropTypes.number,
  suggestedMaxLength: PropTypes.number,
  customClass: PropTypes.string,
  fitToText: PropTypes.bool,
  labelledById: PropTypes.string.isRequired,
  describedById: PropTypes.string,
  openOnFocus: PropTypes.bool,
  highlightOnHover: PropTypes.bool,
  buttonTestId: PropTypes.string,
  inputTestId: PropTypes.string,

  children: childrenShape
};

InlineTextArea.defaultProps = {
  openOnFocus: true,
  highlightOnHover: false
};

export default injectIntl(InlineTextArea);
